{
    "productDashboard": {
        "common": {
            "last": "Letzte",
            "for": "Für",
            "days": "Tage",
            "day": "Tag",
            "categories": "Kategorien",
            "open": "Offen",
            "inProgress": "In Bearbeitung",
            "inProgressShort": "In Bearb.",
            "resolved": "Gelöst",
            "clear": "Löschen",
            "selected": "ausgewählt",
            "clearAllFilters": "Alle Filter zurücksetzen"
        },
        "shell": {
            "dataUpdated": "Daten aktualisiert",
            "latestTurn": "letzte Interaktion",
            "records": "Datensätze",
            "ofData": "an Daten",
            "syncing": "Wird synchronisiert…",
            "refresh": "↻ Daten aktualisieren",
            "dataRefreshed": "Daten aktualisiert.",
            "syncFailed": "Synchronisierung konnte nicht gestartet werden.",
            "syncCompletedWithErrors": "Synchronisierung mit Fehlern abgeschlossen:",
            "timeRangeAria": "Zeitraum",
            "overview": "Übersicht",
            "myhelpData": "aus MyHelp-Daten",
            "rangeLabel": "Bereich",
            "rangeAria": "Benutzerdefinierter Zeitraum",
            "rangeFrom": "Von",
            "rangeTo": "Bis",
            "rangeApplyAria": "Zeitraum anwenden",
            "rangeClearAria": "Zeitraum löschen",
            "rangeSelectBoth": "Bitte Start- und Enddatum auswählen.",
            "rangeInvalidOrder": "Das Startdatum muss vor dem Enddatum liegen.",
            "rangeTooWide": "Wählen Sie einen Zeitraum von bis zu",
            "dateRangeCaption": "Zeitraum"
        },
        "overview": {
            "greetingMorning": "Guten Morgen",
            "greetingAfternoon": "Guten Tag",
            "greetingEvening": "Guten Abend",
            "greetingNight": "Gute Nacht",
            "subtitle": "Hier sehen Sie, was heute bei Ihren Produkten passiert.",
            "tabOverview": "Übersicht",
            "tabActionsForYou": "Aktionen für Sie",
            "actionsTitle": "Aktionen für Sie",
            "actionsMeta": "Empfohlene nächste Schritte für das Product Team",
            "kpiTotalQueries": "GESAMTE ABFRAGEN",
            "kpiIncidentsRaised": "GEMELDETE VORFÄLLE (Seit 10. September)",
            "kpiUpcoming": "KOMMENDE FUNKTION",
            "kpiCallback": "RÜCKRUFANFRAGEN (Seit 10. September)",
            "kpiLiveChat": "LIVE-CHAT-ANFRAGEN (Seit 10. September)",
            "viewBreakdown": "Aufschlüsselung →",
            "viewAllIncidents": "Alle Vorfälle →",
            "upcomingTitle": "Neue Funktion in Kürze",
            "upcomingSub": "Weitere Produkteinblicke folgen in Kürze.",
            "topCategories": "Top-Abfragekategorien",
            "viewAll": "Alle anzeigen →",
            "tipQueries": "Abfragen",
            "uniqueUsersTitle": "Eindeutige Nutzer",
            "detailedView": "Detailansicht",
            "usersPerDay": "Eindeutige Nutzer pro Tag",
            "usersPerWeek": "Eindeutige Nutzer pro Woche",
            "usersPerMonth": "Eindeutige Nutzer pro Monat",
            "uniqueUsersTrendTooltipLead": "Vergleicht",
            "uniqueUsersTrendTooltipConnector": "mit",
            "kpiTooltips": {
                "totalQueries": "Gesamtzahl der Anfragen, die über alle Produkte im ausgewählten Zeitraum eingegangen sind.",
                "incidentsRaised": "Aus Chatbot-Konversationen gemeldete Vorfälle, aufgeschlüsselt nach Status.",
                "upcoming": "Eine neue Dashboard-Funktion ist unterwegs — schauen Sie bald wieder vorbei.",
                "callback": "Von Nutzern eingereichte Rückrufanfragen, aufgeschlüsselt nach Sprache.",
                "liveChat": "Von Nutzern eingereichte Live-Chat-Anfragen, aufgeschlüsselt nach Sprache.",
                "feedbackCoverage": "Anteil der Gesamtabfragen, zu denen Nutzerfeedback vorliegt (👍 oder 👎)."
            }
        },
        "totalQueries": {
            "title": "Einblicke in die gesamten Abfragen",
            "queries": "Abfragen",
            "vsPrior": "gegenüber dem Vorzeitraum",
            "chartTitle": "Abfragen nach Kategorie",
            "breakdownTitle": "Kategorie-Aufschlüsselung",
            "thCategory": "KATEGORIE",
            "thQueries": "ABFRAGEN",
            "thShare": "ANTEIL",
            "thDistribution": "VERTEILUNG",
            "tipQueries": "Abfragen",
            "tipShare": "Anteil %",
            "searchPlaceholder": "Suchen",
            "matchesSuffix": "Treffer",
            "matchSuffix": "Treffer"
        },
        "incidents": {
            "title": "Problemkategorien",
            "incidents": "Vorfälle",
            "thId": "ID",
            "thIssue": "ABFRAGE / PROBLEM",
            "thCategory": "KATEGORIE",
            "thProduct": "PRODUKT",
            "thCompany": "UNTERNEHMEN",
            "thSeverity": "SCHWEREGRAD",
            "thStatus": "STATUS",
            "empty": "Keine MyHelp-Vorfälle in diesem Zeitraum.",
            "severityHigh": "Hoch",
            "severityMedium": "Mittel",
            "severityLow": "Niedrig",
            "incident": "Vorfall",
            "breakdownTitle": "Kategorie-Aufschlüsselung",
            "thIncidents": "VORFÄLLE",
            "thShare": "ANTEIL",
            "thDistribution": "VERTEILUNG",
            "searchPlaceholder": "Suchen",
            "matchesSuffix": "Treffer",
            "matchSuffix": "Treffer"
        },
        "incidentCategory": {
            "titlePrefix": "Vorfälle in",
            "loadError": "Vorfälle konnten nicht geladen werden.",
            "incident": "Vorfall",
            "incidents": "Vorfälle",
            "closeAria": "Schließen",
            "thDate": "DATUM",
            "empty": "Keine Vorfälle für diese Kategorie gefunden.",
            "loading": "Wird geladen…",
            "loadMorePrefix": "Mehr laden (zeige",
            "of": "von"
        },
        "userSentiment": {
            "title": "Einblicke in das Nutzerfeedback",
            "summaryLikes": "Likes",
            "summaryDislikes": "Dislikes",
            "last": "Letzte",
            "days": "Tage",
            "likes": "Likes",
            "dislikes": "Dislikes",
            "chartTitle": "Likes vs. Dislikes nach Kategorie",
            "detailTitle": "Detailliertes Feedback nach Kategorie",
            "positive": "Positiv",
            "thingsWell": "Was gut lief",
            "thingsAttention": "Was Aufmerksamkeit braucht",
            "askAiHint": "KI-Assistenten dazu fragen (öffnet in neuem Tab)",
            "searchPlaceholder": "Suchen",
            "matchesSuffix": "Treffer",
            "matchSuffix": "Treffer"
        },
        "products": {
            "title": "Produktkategorien",
            "products": "Produkte",
            "queryVolume": "Abfragevolumen",
            "incidents": "Vorfälle",
            "sentiment": "Stimmung",
            "healthScore": "Zustandswert"
        },
        "companyFilter": {
            "allCompanies": "Alle Unternehmen",
            "allCompaniesShort": "Alle Unternehmen",
            "selectedSuffix": "Unternehmen ausgewählt",
            "filterAria": "Nach Unternehmen filtern",
            "searchPlaceholder": "Unternehmen suchen…",
            "noMatchPrefix": "Keine Unternehmen entsprechen"
        },
        "clusterFilter": {
            "allClusters": "Alle Cluster",
            "allClustersShort": "Alle Cluster",
            "selectedSuffix": "Cluster ausgewählt",
            "filterAria": "Nach Cluster filtern",
            "searchPlaceholder": "Cluster suchen…",
            "noMatchPrefix": "Keine Cluster entsprechen"
        },
        "categoryFilter": {
            "allCategories": "Alle Kategorien",
            "selectedSuffix": "Kategorien ausgewählt",
            "filterAria": "Nach Kategorie filtern",
            "searchPlaceholder": "Kategorien suchen…",
            "allCategoriesShort": "Alle Kategorien",
            "selectedShort": "ausgewählt",
            "clear": "Zurücksetzen",
            "noMatchPrefix": "Keine Kategorien entsprechen"
        },
        "categoryQueries": {
            "like": "Gefällt mir",
            "dislike": "Gefällt mir nicht",
            "titlePrefix": "Abfragen in",
            "loadError": "Abfragen konnten nicht geladen werden.",
            "query": "Abfrage",
            "queries": "Abfragen",
            "preparing": "Wird vorbereitet…",
            "downloadExcel": "⬇ Excel herunterladen",
            "closeAria": "Schließen",
            "thQuery": "ABFRAGE",
            "thSentiment": "STIMMUNG",
            "thDate": "DATUM",
            "thSource": "QUELLE",
            "thLanguage": "SPRACHE",
            "thCompany": "UNTERNEHMEN",
            "colQuery": "Abfrage",
            "colSentiment": "Stimmung",
            "colDate": "Datum",
            "colSource": "Quelle",
            "colLanguage": "Sprache",
            "colCompany": "Unternehmen",
            "empty": "Keine Abfragen für diese Kategorie gefunden.",
            "loading": "Wird geladen…",
            "loadMorePrefix": "Mehr laden (zeige",
            "of": "von",
            "sortSentimentHint": "Klicken, um nach Stimmung zu sortieren",
            "sortDateHint": "Klicken, um nach Datum zu sortieren"
        },
        "feedbackPie": {
            "likes": "Likes",
            "dislikes": "Dislikes",
            "noFeedback": "Kein Feedback",
            "coverage": "FEEDBACK-ABDECKUNG",
            "meta": "der Gesamtabfragen",
            "feedback": "Feedback",
            "noData": "Keine Daten",
            "viewFeedback": "Nutzerfeedback →"
        },
        "requestCard": {
            "empty": "Keine Anfragen in diesem Zeitraum.",
            "breakdown": "Aufschlüsselung →"
        },
        "requestBreakdown": {
            "titleCallback": "Rückrufanfragen — Sprachaufschlüsselung",
            "titleLiveChat": "Live-Chat-Anfragen — Sprachaufschlüsselung",
            "breakdownTitle": "Sprachaufschlüsselung",
            "thLanguage": "SPRACHE",
            "thCount": "ANZAHL",
            "thShare": "ANTEIL",
            "thDistribution": "VERTEILUNG",
            "language": "Sprache",
            "languages": "Sprachen",
            "request": "Anfrage",
            "requests": "Anfragen",
            "empty": "Keine Anfragen in diesem Zeitraum."
        },
        "tabError": {
            "title": "Dashboard-Daten konnten nicht geladen werden",
            "message": "Der Datendienst hat nicht geantwortet. Bitte erneut versuchen — es werden keine Daten angezeigt, damit hier nichts geschätzt wird."
        },
        "actionItems": {
            "knowledgeArticles": {
                "title": "Wissensartikel erstellen / aktualisieren",
                "hint": "Halten Sie Ihre Produktinhalte korrekt und aktuell",
                "childTitle": "Wissensdatenbank erstellen und aktualisieren",
                "childHint": "So erstellen und aktualisieren Sie die Wissensdatenbank."
            },
            "scripts": {
                "title": "Skripte über Nexthink Remote Actions erstellen und bereitstellen",
                "hint": "Automatisieren Sie die Fehlerbehebung, indem Sie eine Remote-Aktion auf dem Gerät des Benutzers aktivieren",
                "childTitle": "Link zur Bestellung von Nexthink",
                "childHint": "Remote-Aktionsverwaltung"
            }
        }
    }
}
